import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-snapshot-setup",
	templateUrl: "./snapshot-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class SnapshotSetupComponent implements OnInit {
	changesToSave: boolean = false;

	loaded: boolean = false;

	moment: any = moment;

	snapshots: {
		label: string;
		value: string;
		date: Date;
	}[];

	timestamp;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService, public userService: UserService) {}

	ngOnInit(): void {
		this.snapshotsGet();
	}

	async snapshotsGet() {
		const resp = await this.focuslink.ooGetSnapshots(this.venueService.subscriptionVenue.value.key);
		this.snapshots = resp.map((s) => ({
			label: moment(s).format("l LTS"),
			value: s,
			date: this.app.moment(s).toDate(),
			sortVal: moment(s).unix(),
		}));
		this.snapshots = this.snapshots.sort((a, b) => (moment(a.value).unix() < moment(b.value).unix() ? 1 : -1));
	}

	async snapshotPost() {
		try {
			await this.focuslink.ooPostSnapshot(this.venueService.subscriptionVenue.value.key);
			this.app.msgSvc.add({
				severity: "success",
				detail: "Menu snapshot created",
			});
		} catch (e) {
			this.app.msgSvc.add({
				severity: "error",
				detail: "Error posting snapshot",
			});
		}
		await this.snapshotsGet();
	}

	async restoreSnapshot(snapshot?: string) {
		this.app.confirmation.confirm({
			message: `Restoring a Snapshot will revert all menu changes to the date of the restore point. Proceed?`,
			accept: async () => {
				await this.focuslink.ooRestoreSnapshot(this.venueService.subscriptionVenue.value.key, snapshot);
				this.app.msgSvc.add({
					severity: "success",
					detail: "Snapshot Restore Request Submitted",
				});
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	async rekeyFromSnapshot(snapshotKey: string) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to rekey the menu from this snapshot? Bad things can happen!`,
			accept: async () => {
				try {
					await this.focuslink.ooRekeyFromSnapshot(this.venueService.subscriptionVenue.value.key, snapshotKey);
					this.app.msgSvc.add({ severity: AppMessageSeverity.BLUE, summary: "", detail: `Menu Rekey Requested. Check Slack for details` });
				} catch (error) {
					this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Menu Rekey request failed.` });
				}
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	updateTimestamp() {
		this.timestamp = new Date().getTime();
	}
}
